import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import IpaAllInputImage from "../../../image/for-style-change/for-about/sch-input-manwoman-h125.jpg"
import IpaAllMaskImage from "../../../image/for-style-change/for-about/sch-mask-manwoman-1-h100.jpeg"
import IpaAllStyleImage from "../../../image/for-style-change/option-description/eta/sch-style-oil-painting-h100.jpeg";
import IpaAllOutputImage1 from "../../../image/for-style-change/for-about/sch-manwoman-output-oil-painting-style-h125.jpeg";
import IpaAllOutputImage2 from "../../../image/for-style-change/option-description/ipaAll/manwoman-output-ipa-all-125.jpeg";

function StyleChangeDescIpaAll() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('syleChangeOptions20', 'User can turn on this input, when user want to tranfer both style and shape of Style image.')}
          {' '}
          {t('syleChangeOptions21', 'Other inputs affect how much information is transfered.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaAllInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaAllMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaAllStyleImage}
              />
              {t('aboutStyleChange06', 'Style image')}
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">

            <div>
              <img className="diffsionOptionDescImage"
                src={IpaAllOutputImage1}
              />
              -
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaAllOutputImage2}
              />
              + (Add Shape)
            </div>
          </div>
        </div>
      </div>
    )
  }


export default StyleChangeDescIpaAll